/**
 * Time range filtering for events.
 * Filters NormalizedEvent[] to only include events within the selected time window.
 */

import type { NormalizedEvent } from '@/sources/base-source';
import type { TimeRange } from '@/core/store';

/** Duration in milliseconds for each time range option. */
const RANGE_MS: Record<TimeRange, number> = {
  '1h': 3_600_000,
  '6h': 21_600_000,
  '24h': 86_400_000,
  '48h': 172_800_000,
  '7d': 604_800_000,
  'all': Infinity,
};

/**
 * Filter events to those within the given time range.
 * Returns all events if range is 'all'.
 * If timeCursor is set, also excludes events after the cursor timestamp.
 */
export function filterEventsByTimeRange(
  events: NormalizedEvent[],
  range: TimeRange,
  timeCursor?: number | null,
): NormalizedEvent[] {
  let filtered = events;

  if (range !== 'all') {
    const cutoff = Date.now() - RANGE_MS[range];
    filtered = filtered.filter((e) => new Date(e.timestamp).getTime() >= cutoff);
  }

  if (timeCursor != null) {
    filtered = filtered.filter((e) => new Date(e.timestamp).getTime() <= timeCursor);
  }

  return filtered;
}
